import * as actions from './actions';

const initialState = {
  products: [],
  currentProduct: null,
  presentations: [],
  totalCount: 0,
  loading: false,
  error: null,
  saving: false,
  saveError: null,
  uploading: false,
  uploadError: null,
};

export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    // Fetch Products List
    case actions.FETCH_ADMIN_PRODUCTS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.FETCH_ADMIN_PRODUCTS.SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.data.results || [],
        totalCount: action.payload.data.count || 0,
        error: null,
      };
    case actions.FETCH_ADMIN_PRODUCTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch Single Product
    case actions.FETCH_ADMIN_PRODUCT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.FETCH_ADMIN_PRODUCT.SUCCESS:
      return {
        ...state,
        loading: false,
        currentProduct: action.payload.data,
        error: null,
      };
    case actions.FETCH_ADMIN_PRODUCT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Product
    case actions.CREATE_PRODUCT.REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case actions.CREATE_PRODUCT.SUCCESS:
      return {
        ...state,
        saving: false,
        currentProduct: action.payload.data,
        products: [action.payload.data, ...state.products],
        saveError: null,
      };
    case actions.CREATE_PRODUCT.FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };

    // Update Product
    case actions.UPDATE_PRODUCT.REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case actions.UPDATE_PRODUCT.SUCCESS:
      return {
        ...state,
        saving: false,
        currentProduct: action.payload.data,
        products: state.products.map((p) =>
          p.id === action.payload.data.id ? action.payload.data : p
        ),
        saveError: null,
      };
    case actions.UPDATE_PRODUCT.FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };

    // Delete Product
    case actions.DELETE_PRODUCT.REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case actions.DELETE_PRODUCT.SUCCESS:
      return {
        ...state,
        saving: false,
        products: state.products.filter((p) => p.id !== action.payload.id),
        saveError: null,
      };
    case actions.DELETE_PRODUCT.FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };

    // Upload Product Images
    case actions.UPLOAD_PRODUCT_IMAGES.REQUEST:
      return {
        ...state,
        uploading: true,
        uploadError: null,
      };
    case actions.UPLOAD_PRODUCT_IMAGES.SUCCESS:
      return {
        ...state,
        uploading: false,
        // Update currentProduct's images if we're viewing that product
        currentProduct: state.currentProduct
          ? {
              ...state.currentProduct,
              images_on_product: [
                ...(state.currentProduct.images_on_product || []),
                ...action.payload.data.images,
              ],
            }
          : null,
        uploadError: null,
      };
    case actions.UPLOAD_PRODUCT_IMAGES.FAILURE:
      return {
        ...state,
        uploading: false,
        uploadError: action.payload,
      };

    // Delete Product Image
    case actions.DELETE_PRODUCT_IMAGE.REQUEST:
      return {
        ...state,
        uploading: true,
        uploadError: null,
      };
    case actions.DELETE_PRODUCT_IMAGE.SUCCESS:
      return {
        ...state,
        uploading: false,
        currentProduct: state.currentProduct
          ? {
              ...state.currentProduct,
              images_on_product: (state.currentProduct.images_on_product || []).filter(
                (img) => img.id !== action.payload.imageId
              ),
            }
          : null,
        uploadError: null,
      };
    case actions.DELETE_PRODUCT_IMAGE.FAILURE:
      return {
        ...state,
        uploading: false,
        uploadError: action.payload,
      };

    // Fetch Presentations
    case actions.FETCH_PRESENTATIONS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.FETCH_PRESENTATIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        presentations: action.payload.data.results || action.payload.data || [],
        error: null,
      };
    case actions.FETCH_PRESENTATIONS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Presentation
    case actions.CREATE_PRESENTATION.REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case actions.CREATE_PRESENTATION.SUCCESS:
      return {
        ...state,
        saving: false,
        presentations: [...state.presentations, action.payload.data],
        currentProduct: state.currentProduct
          ? {
              ...state.currentProduct,
              presentations: [...(state.currentProduct.presentations || []), action.payload.data],
            }
          : null,
        saveError: null,
      };
    case actions.CREATE_PRESENTATION.FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };

    // Update Presentation
    case actions.UPDATE_PRESENTATION.REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case actions.UPDATE_PRESENTATION.SUCCESS:
      return {
        ...state,
        saving: false,
        presentations: state.presentations.map((p) =>
          p.id === action.payload.data.id ? action.payload.data : p
        ),
        currentProduct: state.currentProduct
          ? {
              ...state.currentProduct,
              presentations: (state.currentProduct.presentations || []).map((p) =>
                p.id === action.payload.data.id ? action.payload.data : p
              ),
            }
          : null,
        saveError: null,
      };
    case actions.UPDATE_PRESENTATION.FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };

    // Delete Presentation
    case actions.DELETE_PRESENTATION.REQUEST:
      return {
        ...state,
        saving: true,
        saveError: null,
      };
    case actions.DELETE_PRESENTATION.SUCCESS:
      return {
        ...state,
        saving: false,
        presentations: state.presentations.filter((p) => p.id !== action.payload.id),
        currentProduct: state.currentProduct
          ? {
              ...state.currentProduct,
              presentations: (state.currentProduct.presentations || []).filter(
                (p) => p.id !== action.payload.id
              ),
            }
          : null,
        saveError: null,
      };
    case actions.DELETE_PRESENTATION.FAILURE:
      return {
        ...state,
        saving: false,
        saveError: action.payload,
      };

    // Clear current product
    case actions.CLEAR_CURRENT_PRODUCT:
      return {
        ...state,
        currentProduct: null,
        presentations: [],
      };

    default:
      return state;
  }
}
